import React from 'react';
import { useParams, useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { openApply } from '../../../store/blueprints/blueprintsReducer';
import { deleteBlueprintThunk } from '../../../store/blueprints/blueprintsActions';
import { BLUEPRINTS_ROOT } from './blueprintRoutes';
import BlueprintDetailContent from './BlueprintDetailContent';
import styles from './BlueprintDetailView.module.css';

const BlueprintDetailView = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className={styles.page}>
      <BlueprintDetailContent
        id={id}
        onClose={() => history.push(BLUEPRINTS_ROOT)}
        onEdit={bpId => history.push(`${BLUEPRINTS_ROOT}/${bpId}/edit`)}
        onDelete={bpId => {
          dispatch(deleteBlueprintThunk(bpId) as never);
          history.push(BLUEPRINTS_ROOT);
        }}
        onAddToCatalog={bpId => dispatch(openApply(bpId))}
      />
    </div>
  );
};

export default BlueprintDetailView;
